import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function MobileBottomCTA() {
  const [isVisible, setIsVisible] = useState(true);
  const footerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    footerRef.current = document.querySelector("footer");
    if (!footerRef.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(!entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-muted-border shadow-[0_-4px_12px_rgba(0,0,0,0.06)] transition-transform duration-300 md:hidden ${
        isVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="grid grid-cols-3 h-16">
        <a
          href={`tel:${COMPANY.phone}`}
          className="flex flex-col items-center justify-center gap-1 text-primary-deep"
        >
          <Phone className="w-5 h-5" />
          <span className="text-[0.7rem] font-medium">Call</span>
        </a>
        <a
          href={COMPANY.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-1 bg-success text-white"
        >
          <MessageCircle className="w-5 h-5" />
          <span className="text-[0.7rem] font-medium">WhatsApp</span>
        </a>
        <Link
          to="/contact"
          className="flex flex-col items-center justify-center gap-1 text-white bg-secondary-blue"
        >
          <FileText className="w-5 h-5" />
          <span className="text-[0.7rem] font-medium">Inquiry</span>
        </Link>
      </div>
    </div>
  );
}
